import { sharedTracker } from '../Tracker';
import events from '../events';

export const trackChangedUserRole = project => sharedTracker
	.trackCollaborationAction( {
		action: events.collaboration.PROJECT_ROLE_EDITED,
		label: project && project.name
	} );

export const trackChangedProjectsSort = sortOption => sharedTracker
	.trackProjectAction( {
		action: events.project.PROJECT_SORTED,
		label: sortOption.name
	} );

export const trackChangedProjectsFilter = filterOption => sharedTracker
	.trackProjectAction( {
		action: events.project.PROJECT_FILTERED,
		label: filterOption.name
	} );

export const trackCustomSortedProjects = () => sharedTracker
	.trackProjectAction( {
		action: events.project.PROJECT_CUSTOM_SORTED
	} );

export const trackSearchedProjects = ( filterText ) => {
	if ( !filterText || filterText.length === 0 ) { return; }

	sharedTracker.trackProjectAction( {
		action: events.project.PROJECT_SEARCHED
	} );
};

export const trackClickedLoginForSharedProject = project => sharedTracker
	.trackCollaborationAction( {
		action: events.collaboration.CLICKED_LOGIN_FOR_SHARED_PROJECT,
		label: project && project.name
	} );

export const trackClickedRegisterForSharedProject = project => sharedTracker
	.trackCollaborationAction( {
		action: events.collaboration.CLICKED_REGISTER_FOR_SHARED_PROJECT,
		label: project && project.name
	} );

export const trackProjectCreated = ( {
	projectName, labelGroupsCount, collaboratorGroupsCount, inviteWorkspaceMembers
} ) => sharedTracker
	.trackProjectAction( {
		action: events.project.PROJECT_CREATED,
		label: projectName,
		label_groups_count: labelGroupsCount,
		collaborator_groups_count: collaboratorGroupsCount,
		invite_workspace_members: inviteWorkspaceMembers
	} );

export const trackProjectDownloaded = () => sharedTracker
	.trackProjectAction( {
		action: events.project.PROJECT_DOWNLOADED
	} );

export const trackProjectDeleted = () => sharedTracker
	.trackProjectAction( {
		action: events.project.PROJECT_DELETED
	} );

export const trackProjectHidden = () => sharedTracker
	.trackProjectAction( {
		action: events.project.PROJECT_HIDDEN
	} );

export const trackProjectUnhidden = () => sharedTracker
	.trackProjectAction( {
		action: events.project.PROJECT_UNHIDDEN
	} );

export const trackProjectNotificationsMutedStatusChanged = ( {
	projectID, wasMuted, buttonLocation
} ) => sharedTracker
	.trackProjectAction( {
		action: events.project.PROJECT_NOTIFICATIONS_MUTED_STATUS_CHANGED,
		project_id: projectID,
		status: wasMuted ? 'mute' : 'unmute',
		button: buttonLocation
	} );

export const trackProjectPinned = () => sharedTracker
	.trackProjectAction( { action: events.project.PROJECT_PINNED } );

export const trackProjectUnpinned = () => sharedTracker
	.trackProjectAction( { action: events.project.PROJECT_UNPINNED } );

export const trackProjectNewItemButtonClicked = ( { isFlatViewEnabled } ) => sharedTracker
	.trackProjectAction( {
		action: events.project.PROJECT_NEW_ITEM_BUTTON_CLICKED,
		flat_view_enabled: isFlatViewEnabled
	} );

// Share project
export const trackInvitedProjectMembers = ( { project, emails, role } ) => {
	sharedTracker
		.trackCollaborationAction( {
			action: events.collaboration.INVITED_PROJECT_MEMBERS,
			project_id: project && project.id,
			project_name: project && project.name,
			amount_invited: emails.length,
			role: role?.replace( 'Project', '' )
		} );
}

export const trackProjectMemberRoleEdited = ( { project, newRole } ) => {
	sharedTracker
		.trackCollaborationAction( {
			action: events.collaboration.PROJECT_MEMBER_ROLE_EDITED,
			project_id: project && project.id,
			project_name: project && project.name,
			new_role: newRole?.replace( 'Project', '' )
		} );
}

export const trackProjectLinkShared = ( { allowsDownload } ) => sharedTracker
	.trackProjectAction( {
		action: events.project.PROJECT_LINK_SHARED,
		allows_download: allowsDownload
	} );

export const trackManagerSeatRequestedForOthers = ( { projectID } ) => sharedTracker
	.trackCollaborationAction( {
		action: events.collaboration.MANAGER_SEAT_REQUESTED_FOR_OTHERS,
		project_id: projectID
	} );

export const trackManagerPermissionsUpgradeRequested = ( { projectID, origin } ) => sharedTracker
	.trackCollaborationAction( {
		action: events.collaboration.MANAGER_PERMISSIONS_UPGRADE_REQUESTED,
		project_id: projectID,
		origin
	} );

export const trackDownloadPermissionsChanged = ( { projectID, reviewerDownloadsEnabled } ) => sharedTracker
	.trackCollaborationAction( {
		action: events.collaboration.DOWNLOAD_PERMISSIONS_CHANGED,
		project_id: projectID,
		reviewer_downloads_enabled: reviewerDownloadsEnabled
	} );

export const trackPastCommentsPermissionsChanged = ( { projectID, reviewerPastCommentsEnabled } ) => sharedTracker
	.trackCollaborationAction( {
		action: events.collaboration.COMMENTS_PERMISSIONS_CHANGED,
		project_id: projectID,
		reviewer_past_comments_enabled: reviewerPastCommentsEnabled
	} );
